/** Estado que abre a Nova receita na tela de Documentos (o ditado fica no topo do editor). */
export const NEW_PRESCRIPTION_STATE = {
  prefillDocumentType: 'prescription',
  openDocumentosTab: 'new-document',
} as const
